import VMenu from './VMenu';
export { VMenu };
export default VMenu;
//# sourceMappingURL=index.js.map